export const calculatePercentage = (part, total) => {
    return total === 0 ? 0 : ((part || 0) / total) * 100;
};
//# sourceMappingURL=percentageUtils.js.map